export default __webpack_public_path__ + "static/media/H1018.50c0517f.mp3";